export default __webpack_public_path__ + "6995814085385ea88a5dbce5cdcf1148.glb";